import logo from './logo.svg';
import './App.css';
// import RacingLineVisualizer from './track';
// import GpsTrackViewer from "./GpsTrackViewer";
import RacingLineVisualizer from "./RacingLineVisualizer";
import RedditFeed from "./RedditFeed";


function App() {
  return (
    <div className="App" style={{ display: 'flex', height: '100vh' }}>
      {/* Left: Your racing visualizer */}
      <div style={{ flex: 2, overflow: 'auto' }}>
        <RacingLineVisualizer />
        
      </div>

      {/* Right sidebar: Reddit + Netlify iframe */}
      <div style={{ 
        width: 400, 
        display: 'flex', 
        flexDirection: 'column',
        borderLeft: '2px solid #22d3ee',
        background: '#0d1117'
      }}>
        {/* Reddit Feed */}
        <div style={{ flex: 1, overflow: 'auto' }}>
          <RedditFeed />
        </div>

        {/* Embedded Netlify racing app */}
        <div style={{ height: 400, borderTop: '2px solid #ff4500' }}>
          <iframe
            src="https://racingline.netlify.app/"
            width="100%"
            height="100%"
            title="Racing Line App"
            style={{ border: 'none', display: 'block' }}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
